// src/Dashboard/pages/user/Produits/components/ProductCard.jsx

import React from "react";
import {
  FaArrowRight,
  FaExternalLinkAlt,
  FaInfoCircle,
  FaRocket,
} from "react-icons/fa";

import {
  FALLBACK_PRODUCT_IMAGE,
  getProductDescription,
  getProductImage,
  getProductName,
  hostLabel,
  parseDemoLinks,
  truncateText,
} from "../utils/productsUtils";

export default function ProductCard({ product, onOpen }) {
  const name = getProductName(product);
  const description = getProductDescription(product);
  const image = getProductImage(product);
  const links = parseDemoLinks(product?.lien_url_app);

  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl dark:border-slate-800 dark:bg-slate-950">
      <button
        type="button"
        onClick={onOpen}
        className="relative block w-full overflow-hidden bg-slate-50 text-left dark:bg-slate-900"
        title={`Voir les détails de ${name}`}
      >
        <div className="absolute left-4 top-4 z-10 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-700 shadow-sm ring-1 ring-slate-200 backdrop-blur dark:bg-slate-950/90 dark:text-slate-200 dark:ring-slate-700">
          <FaRocket className="text-[#4CA82F]" />
          Application web
        </div>

        {links.length > 0 && (
          <div className="absolute right-4 top-4 z-10 rounded-full bg-[#013E8E] px-3 py-1.5 text-[11px] font-bold text-white shadow-sm">
            {links.length} lien{links.length > 1 ? "s" : ""}
          </div>
        )}

        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={image}
            alt={name}
            className="h-full w-full object-contain p-5 transition duration-500 group-hover:scale-[1.05]"
            loading="lazy"
            onError={(event) => {
              event.currentTarget.src = FALLBACK_PRODUCT_IMAGE;
            }}
          />
        </div>

        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-slate-950/65 via-slate-950/25 to-transparent opacity-0 transition group-hover:opacity-100" />
      </button>

      <div className="flex flex-1 flex-col p-5">
        <div className="mb-3">
          <button
            type="button"
            onClick={onOpen}
            className="block w-full text-left"
            title={`Voir ${name}`}
          >
            <h3 className="text-xl font-bold leading-tight tracking-tight text-slate-950 transition group-hover:text-[#013E8E] dark:text-white dark:group-hover:text-blue-300 sm:text-2xl">
              {name}
            </h3>
          </button>

          <div className="mt-3 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />
        </div>

        <p className="flex-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
          {truncateText(description, 155)}
        </p>

        {links.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1.5">
            {links.slice(0, 2).map((link, index) => (
              <span
                key={`${link}-${index}`}
                className="inline-flex items-center gap-1.5 rounded-full bg-slate-50 px-2.5 py-1 text-[11px] font-bold text-slate-600 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700"
              >
                {hostLabel(link, index)}
                <FaExternalLinkAlt className="text-[9px] opacity-60" />
              </span>
            ))}

            {links.length > 2 && (
              <span className="rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-bold text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-200 dark:ring-indigo-800/60">
                +{links.length - 2}
              </span>
            )}
          </div>
        )}

        <div className="mt-5">
          <button
            type="button"
            onClick={onOpen}
            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white transition hover:bg-[#013E8E] dark:bg-white dark:text-slate-950 dark:hover:bg-blue-100"
          >
            <FaInfoCircle />
            Détails de l’application
            <FaArrowRight className="text-xs transition group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </article>
  );
}